<template>
	<div>
		<h1 class="mb-4 text-center">{{ $t("studentGroupsDetails.students") }}</h1>
		<form class="row" @submit.prevent="searchStudents">
			<div class="col-2">
				<span for="id">{{ $t("studentGroupsDetails.id") }}</span>
				<input
					type="number"
					id="id"
					v-model.number="id"
					class="form-control"
					min="0"
					placeholder="1"
				/>
			</div>
			<div class="col-5">
				<span for="group_name">{{
					$t("studentGroupsDetails.studentName")
				}}</span>
				<input
					type="search"
					id="group_name"
					v-model="name"
					class="form-control"
					:placeholder="$t('studentGroupsDetails.searchHere')"
				/>
			</div>
			<div class="col-5">
				<span for="group_name">{{ $t("studentGroupsDetails.gender") }}</span>
				<select class="form-select" v-model="gender">
					<option selected disabled>{{
						$t("studentGroupsDetails.selectGender")
					}}</option>
					<option value="male">{{ $t("studentGroupsDetails.male") }}</option>
					<option value="female">{{
						$t("studentGroupsDetails.female")
					}}</option>
				</select>
			</div>
			<div class="d-flex align-items-center justify-content-end">
				<button type="submit" class="btn btn-primary text-white me-4">
					{{ $t("studentGroupsDetails.search") }}
				</button>
				<button
					type="reset"
					class="btn btn-danger text-white"
					@click.prevent="reset"
				>
					{{ $t("studentGroupsDetails.clear") }}
				</button>
			</div>
		</form>
		<v-data-table :headers="headers" :items="students">
			<template v-slot:item.actions="{ item }">
				<v-icon small @click="deleteGroup(item)">
					mdi-delete
				</v-icon>
			</template>
		</v-data-table>
	</div>
</template>

<script>
export default {
	name: "StudentGroupsDetails",
	data() {
		return {
			// headers: [
			// 	{ text: "ID", value: "id" },
			// 	{ text: "Name", value: `full_name` },
			// 	{ text: "Gender", value: "gender" },
			// 	{ text: "Age", value: "age" },
			// 	{ text: "Actions", value: "actions", sortable: false },
			// ],
			students: [],
			groupId: 0,
			id: null,
			name: null,
			gender: "Select Gender",
		};
	},
	methods: {
		getStudents() {
			this.axios
				.post(`${process.env.VUE_APP_APIEndPoint}b2b/group/users/list/`, {
					institute_group: this.groupId,
				})
				.then(res => {
					const {
						data: { group_users },
					} = res;

					let newStudents = group_users.map(student => {
						if (!student.age) student.age = "NA";
						if (!student.gender) student.gender = "NA";

						return {
							...student,
							full_name: `${student.first_name} ${student.last_name}`,
						};
					});

					this.students = newStudents;
				});
		},
		deleteGroup(student) {
			Swal.fire({
				title: `${this.$t("studentGroupsDetails.AreYouSureYouWantToDelete")}`,
				showCancelButton: true,
				confirmButtonText: `${this.$t("studentGroupsDetails.yes")}`,
				cancelButtonText: `${this.$t("studentGroupsDetails.close")}`,
			}).then(result => {
				if (result.isConfirmed) {
					this.axios
						.post(
							`${process.env.VUE_APP_APIEndPoint}b2b/group/users/delete/`,
							{
								institute_group: this.groupId,
								users: [student.id],
							},
							this.headers
						)

						.then(res => {
							Swal.fire({
								icon: "success",
								text: `Student deleted successfully`,
							});
							this.getStudents();
						})
						.catch(error => {
							Swal.fire({
								position: "center",
								icon: "error",
								title: "Oops...",
								text: "Something went wrong",
								showConfirmButton: false,
								timer: 1000,
							});
						});
				}
			});
		},
		searchStudents() {
			const data = {
				institute_group: this.groupId,
				user_id: this.id ? this.id : undefined,
				name: this.name ? this.name : undefined,
				gender: this.gender === "Select Gender" ? undefined : this.gender,
			};

			this.axios
				.post(`${process.env.VUE_APP_APIEndPoint}b2b/group/users/list/`, data)
				.then(res => {
					const {
						data: { group_users },
					} = res;

					let newStudents = group_users.map(student => {
						if (!student.age) student.age = "NA";
						if (!student.gender) student.gender = "NA";

						return {
							...student,
							full_name: `${student.first_name} ${student.last_name}`,
						};
					});

					this.students = newStudents;
				});
		},
		reset() {
			this.id = "";
			this.name = "";
			this.gender = "Select Gender";
			this.getStudents();
		},
	},
	created() {
		this.groupId = +this.$route.params.id;
		this.getStudents();
	},
	computed: {
		headers() {
			return [
				{ text: this.$t("studentList.studentID"), value: "id" },
				{ text: this.$t("studentList.fullName"), value: `full_name` },
				{ text: this.$t("studentList.gender"), value: "gender" },
				{ text: this.$t("studentList.age"), value: "age" },
				{ text: this.$t("tables.actions"), value: "actions", sortable: false },
			];
		},
	},
};
</script>
